'use client';

import React, { FC, useState } from 'react';
import classnames from 'classnames';
import SubDividerTabs from '@/components/atoms/Tabs/SubDividerTabs';
import { Tabs } from '@/components/atoms/Tabs/Tabs';
import { CURRENCIES, Currency, CrossRateTabs, TABS_LABEL, currenciesJoinString } from './config';
import Table from './Table';
import { useQuery } from '@tanstack/react-query';
import { GETv1CurrenciesComparison } from '@/api/currency';
import { RectangleSkeleton } from '@/components/atoms/Skeleton';

type PriceHeatProps = {
  isDesktop: boolean;
};

const PriceHeat: FC<PriceHeatProps> = ({ isDesktop }) => {
  const { data, isSuccess } = useQuery({
    queryKey: ['cross-rate'],
    queryFn: () => GETv1CurrenciesComparison(currenciesJoinString),
    select: res => {
      const data = res?.data || [];
      return CURRENCIES.map(base => {
        return CURRENCIES.map(quote => (base === quote ? null : data[base + quote]));
      });
    },
    refetchInterval: 60000 // 每一分鐘重新獲取一次數據
  });

  const [tab, setTab] = useState(CrossRateTabs.PRICE);

  return (
    <>
      {isSuccess ? (
        <>
          <SubDividerTabs className={classnames('my-4 ml-4', 'hidden md:flex')} tabs={TABS_LABEL} onClick={setTab} />
          <Tabs className={classnames('mt-4 bg-white', 'md:hidden')} tabs={TABS_LABEL} onClick={setTab} />
          <Table tab={tab} data={data as (Currency | null)[][]} isDesktop={isDesktop} />
        </>
      ) : (
        <RectangleSkeleton height={496} width='100%' className='mb-8' />
      )}
    </>
  );
};

export default PriceHeat;
